import { LoadablePaint } from '@confluence/loadable';

export const ShareableLinkSpaceAdminConfigurationLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareableLinkConfiguration" */ '../common/components/ConfigPage.tsx'
			)
		).ConfigPage,
});
